import React, { useContext } from 'react';

import { LockerManagementContext } from '@/context/LockerManagmentContext';
import { BuildPath } from  '@/helpers/Paths';

import {LockerContextRefreshType as Table} from  '@/interfaces/LockerManagement'

const NotFound = ({message, table}:{message: string, table: Table}) => {
    const { isLoading, searchParams } = useContext(LockerManagementContext)

    const { searchTerm, filter } = searchParams[table]

    if( searchTerm || filter ) {
        message = 'No Locker Files found matching your search criteria'
    }

    return (
        <div className="not-found-wrapper">
            {isLoading 
                ? <h4>Fetching Locker Files...</h4>
                : <>  
                    <img src={`${BuildPath()}/images/locker/filenotFound.svg`} alt="batch icon"/>
                        <h4>{message}</h4>
                </>
                }
        </div>
    );
}

export default NotFound